<template>
  <div class="RegisterSuccess">
    <!--header-->
    <HeaderNav title="提交成功"></HeaderNav>
    <!-- content -->
    <div class="reg-step3-content">
      <div class="submit-wrap">
        <img src="./images/提交成功.png" height="150" width="150" />
        <h1>提交成功</h1>
        <span>审核大概需要1个工作日。</span>
      </div>
    </div>
    <!-- 底部 -->
    <FooterNav class="footerNav"></FooterNav>
  </div>
</template>

<script>
import HeaderNav from '@/components/HeaderNav'
import FooterNav from '@/components/FooterNav'
export default {
  components: { HeaderNav, FooterNav },
  data () {
    return {}
  },
  methods: {}
}
</script>

<style lang="less" scoped>
.RegisterSuccess {
  min-height: 700px;
  min-width: 1300px;
  height: 100vh;
  position: relative;
  .reg-step3-content {
    .submit-wrap {
      font-family: PingFangSC-Regular;
      text-align: center;
      margin-top: 120px;
      font-size: 14px;

      h1 {
        font-weight: bold;
        font-size: 20px;
        line-height: 28px;
        margin: 0;
      }

      a {
        font-size: 14px;
      }

      span {
        line-height: 36px;
        color: #333;
      }
    }
  }
  .footerNav {
    position: absolute;
    bottom: 10px;
    width: 100%;
  }
}
</style>
